/**
 * Bundled fallback config — used when /site.config.json is missing, returns 404,
 * or fails to parse.  Keep this in sync with /public/site.config.json so the
 * site always has *something* to render.
 *
 * Production content lives in /public/site.config.json — edit there and refresh.
 *
 * The `meta`, `ui`, and `homeOrder` blocks are the *plumbing* of the public
 * site — page <title>, button labels, fallback section eyebrows, and the
 * order of bands on the Home page.  Every hardcoded English word that used
 * to live in JSX has been moved here so the site can be re-skinned (or
 * re-translated) by editing JSON only.
 */
const defaultConfig = {
  meta: {
    defaultTitle:       'HHMS Home Healthcare',
    defaultDescription: 'Compassionate home healthcare and personal care.',
    faviconUrl:         null,
    titles:             {},
  },
  ui: {
    stepLabel:           'STEP',
    navBurgerOpenLabel:  'Open menu',
    navBurgerCloseLabel: 'Close menu',
    form: {
      submitLabel:        'Send message',
      submittingLabel:    'Sending…',
      successHeading:     'Message received',
      successDefault:     'Thanks — we\'ll be in touch.',
      selectPlaceholder:  'Select…',
      requiredMarker:     '*',
      requiredAriaSuffix: 'required',
    },
    fallbacks: {
      aboutEyebrow:    'About us',
      aboutTitle:      'About',
      featuresEyebrow: 'Our services',
      featuresTitle:   'Services',
      contactEyebrow:  'Contact',
      contactTitle:    'Get in touch',
      footerCopyright: '©',
    },
  },
  homeOrder: [
    'trustBar', 'about', 'services', 'howItWorks', 'whyUs',
    'testimonials', 'serviceArea', 'insurance', 'faq', 'ctaBand',
  ],
  brand: {
    name: 'HHMS',
    fullName: 'Home Healthcare Management System',
    tagline: 'Coordinated home healthcare, simplified.',
    logoEmoji: '⚕️',
    logoUrl: null,
  },
  theme: {
    primary:      '#7b1e3c',
    primaryDark:  '#7b1e3c',
    primaryLight: '#94335a',
    accent:       '#b0186a',
    heroGradient: 'linear-gradient(135deg, #4a1228 0%, #7b1e3c 60%, #94335a 100%)',
    ctaTextColor: '#ffffff',
  },
  nav: {
    links: [
      { label: 'Home',     href: '/home'     },
      { label: 'About',    href: '/about'    },
      { label: 'Services', href: '/features' },
      { label: 'Contact',  href: '/contact'  },
    ],
    ctaPrimary:   { label: 'Refer a patient', href: '/contact' },
    ctaSecondary: null,
  },
  hero: {
    eyebrow: '',
    title: 'HHMS — coordinated home healthcare.',
    subtitle: 'Configure /site.config.json to replace this hero copy.',
    ctaPrimary:   { label: 'Contact us', href: '/contact' },
    ctaSecondary: null,
    metrics: [],
  },
  trustBar:     null,
  about:        null,
  features:     { items: [] },
  howItWorks:   null,
  whyUs:        null,
  testimonials: null,
  serviceArea:  null,
  insurance:    null,
  faq:          null,
  ctaBand:      null,
  contact:      null,
  footer: {
    copyright: '© HHMS',
    columns: [],
    social:  [],
  },
};

export default defaultConfig;
